import { fields, createSchema, validate as _validate } from '..';

const { requiredText, requiredRadioNumber, urlRequired } = fields;

const schema = createSchema({
  title: requiredText,
  externalLink: urlRequired,
  order: requiredRadioNumber,
});

const validate = (data) => _validate(schema, data);

export default validate;
